import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addPatients = (patientRequest, authToken) => {
  const urlPath = '/patient/addPatient';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: patientRequest,
    additionalHeader: additionalHeader
  });
};
export const updatePatient = (patientRequest, authToken) => {
  const urlPath = '/patient/updatePatient';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: patientRequest,
    additionalHeader: additionalHeader
  });
};

export const getAllPatientDetails = (authToken) => {
  const urlPath = '/patient/getPatientDetails';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getPatientDetailsById = (patientId, authToken) => {
  const urlPath = `/patient/getPatientsById/${patientId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

// export const removePatientById = (patientId) => {
//   const urlPath = `/patient/removePatient/${patientId}`;
//   return API.request({
//     method: HttpMethod.DELETE,
//     urlPath: urlPath
//   });
// };

export const removePatientCompleteDetails = (patientId, authToken) => {
  const urlPath = `/patient/removePatientCompleteDetails/${patientId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.DELETE,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getAllPatientDetailsByDoctorId = (doctorId, authToken) => {
  const urlPath = `/patient/getPatientsByDoctorId/${doctorId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getPatientFullDetailsByConsultantId = (doctorId, authToken) => {
  const urlPath = `/treatment/getPatientFullDetailsByConsultantId/${doctorId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getPatientCompleteDetails = (patientId, authToken) => {
  const urlPath = `/patient/getPatientCompleteDetails/${patientId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};
